let ids = []
console.log(ids)
// window.onload = initializeElements

// function initializeElements () {
  const choice_list = document.getElementById('choice_list_container')
  for (let i = 0; i < choice_list.childNodes.length; i++) {
    const element = choice_list.childNodes[i];
    if(element.nodeName == "#text") {
      
    } else {
      ids.push(element.id)
    }
    
  }
function changeActive(idToActive) {
  for (const id of ids) {
    const checkId = idToActive.includes
    if (id == idToActive && idToActive == 'all-btn'){
      document.getElementById(id).classList.add("faq-list-active")
      const arcodions = document.getElementsByClassName('accordion-first')
      for (const acordion of arcodions) {
        acordion.classList.remove('d-none')
      }
    } else if (id == idToActive) {
      document.getElementById(id).classList.add("faq-list-active")
      const arcodionstoShow = []
      const arcodions = document.getElementsByClassName('accordion-first')
      for (const acordion of arcodions) {
        const option = acordion.getAttribute('option-id')
        if(option.includes(id) ) {
          acordion.classList.remove('d-none')
        } else {
          acordion.classList.add('d-none')
        }
      }
    } else {
      document.getElementById(id).classList.remove("faq-list-active")
    }
  }
}

function allbtn(){
  $('#optimum').removeClass("d-none");
  $('#classic-d').removeClass("d-none");
  $('#multicat').removeClass("d-none");
  $('#use-d').removeClass("d-none");
  $('#issue-d').removeClass("d-none");
  $('#learn-classic').removeClass("d-none");
  $('#use-classic').removeClass("d-none");
  $('#safety').removeClass("d-none");
  for (const [i, id] of ids) {
    if (id == 'allbtn') {
      
    }
    $(`#${id}`).removeClass("faq-list-active")
  }
  $('#classicd-btn').removeClass("faq-list-active");
  $('#all-btn').addClass("faq-list-active");
  $('#multicat-btn').removeClass("faq-list-active");
  $('#classics-btn').removeClass("faq-list-active");
  $('#safety-btn').removeClass("faq-list-active");
}
function classicd(){
  $('#optimum').addClass("d-none");
  $('#multicat').addClass("d-none");
  $('#learn-classic').addClass("d-none");
  $('#use-classic').addClass("d-none");
  $('#safety').addClass("d-none");
  $('#classic-d').removeClass("d-none");
  $('#use-d').removeClass("d-none");
  $('#issue-d').removeClass("d-none");
  $('#classicd-btn').addClass("faq-list-active");
  $('#all-btn').removeClass("faq-list-active");
  $('#multicat-btn').removeClass("faq-list-active");
  $('#classics-btn').removeClass("faq-list-active");
  $('#safety-btn').removeClass("faq-list-active");
}
function multicat(){
  $('#optimum').addClass("d-none");
  $('#classic-d').addClass("d-none");
  $('#learn-classic').addClass("d-none");
  $('#use-classic').addClass("d-none");
  $('#safety').addClass("d-none");
  $('#multicat').removeClass("d-none");
  $('#use-d').removeClass("d-none");
  $('#issue-d').removeClass("d-none");
  $('#multicat-btn').addClass("faq-list-active");
  $('#all-btn').removeClass("faq-list-active");
  $('#classicd-btn').removeClass("faq-list-active");
  $('#classics-btn').removeClass("faq-list-active");
  $('#safety-btn').removeClass("faq-list-active");
}
function classics(){
  $('#optimum').addClass("d-none");
  $('#classic-d').addClass("d-none");
  $('#multicat').addClass("d-none");
  $('#use-d').addClass("d-none");
  $('#issue-d').addClass("d-none");
  $('#safety').addClass("d-none");
  $('#learn-classic').removeClass("d-none");
  $('#use-classic').removeClass("d-none");
  $('#multicat-btn').removeClass("faq-list-active");
  $('#all-btn').removeClass("faq-list-active");
  $('#classicd-btn').removeClass("faq-list-active");
  $('#classics-btn').addClass("faq-list-active");
  $('#safety-btn').removeClass("faq-list-active");
}
function safety(){
  $('#optimum').addClass("d-none");
  $('#classic-d').addClass("d-none");
  $('#multicat').addClass("d-none");
  $('#use-d').addClass("d-none");
  $('#issue-d').addClass("d-none");
  $('#learn-classic').addClass("d-none");
  $('#use-classic').addClass("d-none");
  $('#safety').removeClass("d-none");
  $('#multicat-btn').removeClass("faq-list-active");
  $('#all-btn').removeClass("faq-list-active");
  $('#classicd-btn').removeClass("faq-list-active");
  $('#classics-btn').removeClass("faq-list-active");
  $('#safety-btn').addClass("faq-list-active");
}
function changeitem(){
  if (document.getElementById('all-btnr').selected){
    $('#optimum').removeClass("d-none");
    $('#classic-d').removeClass("d-none");
    $('#multicat').removeClass("d-none");
    $('#use-d').removeClass("d-none");
    $('#issue-d').removeClass("d-none");
    $('#learn-classic').removeClass("d-none");
    $('#use-classic').removeClass("d-none");
    $('#safety').removeClass("d-none");
  } 
  else if (document.getElementById('classicd-btnr').selected){   
    $('#optimum').addClass("d-none");
    $('#multicat').addClass("d-none");
    $('#learn-classic').addClass("d-none");
    $('#use-classic').addClass("d-none");
    $('#safety').addClass("d-none");
    $('#classic-d').removeClass("d-none");
    $('#use-d').removeClass("d-none");
    $('#issue-d').removeClass("d-none");
  } 
  else if(document.getElementById('multicat-btnr').selected){
    $('#optimum').addClass("d-none");
    $('#classic-d').addClass("d-none");
    $('#learn-classic').addClass("d-none");
    $('#use-classic').addClass("d-none");
    $('#safety').addClass("d-none");
    $('#multicat').removeClass("d-none");
    $('#use-d').removeClass("d-none");
    $('#issue-d').removeClass("d-none");
  }
  else if(document.getElementById('classics-btnr').selected){ 
    $('#optimum').addClass("d-none");
    $('#classic-d').addClass("d-none");
    $('#multicat').addClass("d-none");
    $('#use-d').addClass("d-none");
    $('#issue-d').addClass("d-none");
    $('#safety').addClass("d-none");
    $('#learn-classic').removeClass("d-none");
    $('#use-classic').removeClass("d-none");
  }
  else if(document.getElementById('safety-btnr').selected){
    $('#optimum').addClass("d-none");
    $('#classic-d').addClass("d-none");
    $('#multicat').addClass("d-none");
    $('#use-d').addClass("d-none");
    $('#issue-d').addClass("d-none");
    $('#learn-classic').addClass("d-none");
    $('#use-classic').addClass("d-none");
    $('#safety').removeClass("d-none");
  }
}